// src/components/admin/AdminRoute.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import shared from '../../styles/shared.module.css';

// 管理者権限を持つユーザーのみがアクセスできるルート
const AdminRoute = ({ children }) => {
  const { currentUser, isAdmin } = useAuth();
  const [loading, setLoading] = useState(true);
  const [hasAdminAccess, setHasAdminAccess] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!currentUser) {
        setLoading(false);
        return;
      }

      try {
        const adminStatus = await isAdmin(currentUser.uid);
        setHasAdminAccess(adminStatus);
      } catch (error) {
        console.error("管理者権限チェックエラー:", error);
        setHasAdminAccess(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [currentUser, isAdmin]);

  if (loading) {
    return (
      <div className={shared.loadingSpinner}>
        <div className={shared.spinner}></div>
      </div>
    );
  }

  // 管理者権限がない場合はダッシュボードにリダイレクト
  if (!hasAdminAccess) {
    return <Navigate to="/dashboard" />;
  }

  // 管理者権限がある場合は子コンポーネントを表示
  return children;
};

export default AdminRoute;